import React from "react";

/**
 * 24/7 service badge — premium minimalist circular indicator.
 * variant: "solid" (emerald fill, cream text — for light bg)
 *        | "outline" (transparent fill, white border + white text — for dark bg)
 *        | "white" (cream fill, emerald text — for dark bg, alt)
 * size: pixel diameter
 */
export default function ServiceBadge247({ variant = "solid", size = 44, className = "", title = "24/7 service" }) {
  const palettes = {
    solid:   { bg: "#1a1a1a", fg: "#FFFFFF", border: "#1a1a1a" },
    outline: { bg: "transparent", fg: "#FFFFFF", border: "rgba(245,239,224,0.7)" },
    white:   { bg: "#FFFFFF", fg: "#1a1a1a", border: "#FFFFFF" },
  };
  const p = palettes[variant] || palettes.solid;

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full select-none transition-transform duration-300 hover:scale-105 ${className}`}
      style={{
        width: size,
        height: size,
        background: p.bg,
        border: `1.5px solid ${p.border}`,
        boxShadow: variant === "solid" ? "0 6px 18px -8px rgba(15,36,33,0.55)" : "none",
      }}
      title={title}
      aria-label={title}
      data-testid="service-badge-247"
    >
      <svg viewBox="0 0 44 44" width={size} height={size} aria-hidden="true">
        {/* 24 — top-left */}
        <text
          x="14"
          y="20"
          textAnchor="middle"
          fontFamily="'Plus Jakarta Sans', system-ui, sans-serif"
          fontWeight="800"
          fontSize="15"
          fill={p.fg}
          letterSpacing="-0.5"
        >
          24
        </text>
        {/* diagonal slash */}
        <line
          x1="29"
          y1="13"
          x2="15"
          y2="33"
          stroke={p.fg}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        {/* 7 — bottom-right */}
        <text
          x="30"
          y="35"
          textAnchor="middle"
          fontFamily="'Plus Jakarta Sans', system-ui, sans-serif"
          fontWeight="800"
          fontSize="12"
          fill={p.fg}
          letterSpacing="-0.5"
        >
          7
        </text>
      </svg>
    </span>
  );
}
